export default "__VITE_ASSET__vlhPo0Yu__"